import DialogModal from "../../../../../atoms/dialog";
import { APIRoutes } from "../../../../../constants";
import { useFetch } from "../../../../../utils/hooks/useFetch";
import ScheduleCall from "../schedule-call";
import { ScheduleCallFormTypes } from "../schedule-call/helper";
import { useEffect, useState } from "react";
import { getDefaultValues } from "./helper";
import { CircularProgress } from "@mui/material";

type Props = {
    isOpen: boolean;
    handleClose(): void;
    handleSubmitClose(): void;
    callId: number;
}

export function ReScheduleCallDialog({ isOpen, handleClose, callId, handleSubmitClose }: Props) {
  
    const { formattedData: data } = useFetch(APIRoutes.scheduleCall + "?id=" + callId + "&show_columns=fk_pe,fk_project,scheduled_start_time,scheduled_end_time,zoom_meeting_id,call_link,zoom_api_request,title,call_title_for_expert,invitation_text_for_expert,invitation_text,client_participants,research_analyst,call_medium,fk_client,selected_agendas", {
        formatter(data) {
            return data && data[0];
        },
    });
    const { data: allPeAgendas, loading: agendasLoading } = useFetch(
      APIRoutes.PE_AGENDA +
        `?fk_pe=${data?.fk_pe}&fk_project=${data?.fk_project}&show_columns=id,fk_agenda,status&embed=YES&in___status=Sent,RespondedByExpert,RespondedByAdmin`,
      {
        disabled: !data?.fk_pe || !data?.fk_project, // ✅ Don't run until both exist
        variables: [data?.fk_pe, data?.fk_project], // ✅ Prevent calling API with nulls
      }
    );
    const [defaultValues, setDefaultValues] = useState<ScheduleCallFormTypes | null>(null);

    useEffect(() => {
      if (data && allPeAgendas) {
        getDefaultValues(data, setDefaultValues, allPeAgendas);
      }
    }, [data, allPeAgendas]);

    return (
        <DialogModal
            isOpen={isOpen}
            handleClose={handleClose}
            title={"ReSchedule Call"}
        >
            {(data && defaultValues) ?
                <ScheduleCall
                    allowUseContext={false}
                    handleClose={handleClose}
                    handleSubmitClose={handleSubmitClose}
                    pe_id={data.fk_pe}
                    project_id={data.fk_project}
                    defaultValues={defaultValues}
                    call_id={callId}
                    client_id={data.fk_client}
                /> : <CircularProgress sx={{marginTop: "10px"}} />
            }

        </DialogModal>
    )
}